<template>
    <div class="baseMain">
        <div class="baseSearch clearfloat">
            <div class="baseSearchOne">
                <div class="baseSearchOneLeft">
                    <span>筛选项目：</span>
                </div>
                <div class="baseSearchOneRight">
                    <el-select v-model="searchForm.project_id" clearable>
                        <el-option v-for="item in project_id_list" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="baseSearchOne">
                <div class="baseSearchOneLeft">
                    <span>组织部门：</span>
                </div>
                <div class="baseSearchOneRight">
                    <el-cascader v-model="searchForm.org_id" :options="class_id_list" :props="props"
                                 clearable></el-cascader>
                </div>
            </div>
            <div class="baseSearchOne">
                <el-button type="primary" style="margin-left: 20px;" @click="search">搜索</el-button>
                <el-button @click="cleanAll">清空</el-button>
            </div>
        </div>
        <div class="baseTable" style="margin-top: 10px" v-loading="tableLoading">
            <publicTable :publicTableOtherHeight="searchHeight" :publicTableData="tableData">
                <el-table-column prop="org_name" label="组织机构"></el-table-column>
                <el-table-column prop="yingjiao_count" label="应缴人数"></el-table-column>
                <el-table-column prop="yingjiao_price" label="应缴金额"></el-table-column>
                <el-table-column prop="jiaofei_price" label="缴费金额"></el-table-column>
                <el-table-column prop="daijiao_price" label="待缴金额"></el-table-column>
                <el-table-column prop="refund_price" label="退款金额"></el-table-column>
                <el-table-column prop="yijiao_price" label="实际入账"></el-table-column>
                <el-table-column prop="jiaoqi_count" label="已缴齐人数"></el-table-column>
                <el-table-column prop="weijiaoqi_count" label="未缴齐人数"></el-table-column>
                <el-table-column label="操作">
                    <template #default="scope">
                        <el-link class="tableButton" type="primary" @click.prevent="openDetail(scope.row)">
                            查看详情
                        </el-link>
                    </template>
                </el-table-column>
            </publicTable>
        </div>
        <div class="basePage" style="margin-top: 4px;">
            <publicPage ref="publicPageUserStudent" :publicPageTotal="{total:total}"
                        @pageChange="getTableData"></publicPage>
        </div>
        <el-drawer title="详情" v-model="drawer" :close-on-click-modal="false" :destroy-on-close="true" size="80%">
            <div class="rtDetailSearch baseSearch clearfloat">
                <div class="baseSearchOne">
                    <div class="baseSearchOneLeft">
                        <span>姓名：</span>
                    </div>
                    <div class="baseSearchOneRight">
                        <el-input v-model="detailSearchForm.user_name" placeholder="请输入内容" clearable></el-input>
                    </div>
                </div>
                <div class="baseSearchOne">
                    <div class="baseSearchOneLeft">
                        <span>是否欠费：</span>
                    </div>
                    <div class="baseSearchOneRight">
                        <el-select v-model="detailSearchForm.is_arrears" placeholder="请选择" clearable>
                            <el-option v-for="item in is_arrears_list" :key="item.value" :label="item.label"
                                       :value="item.value"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="baseSearchOne">
                    <div class="baseSearchOneLeft">
                        <span>筛选项目：</span>
                    </div>
                    <div class="baseSearchOneRight">
                        <el-select v-model="detailSearchForm.project_id" placeholder="请选择" clearable>
                            <el-option v-for="item in project_id_list" :key="item.value" :label="item.label"
                                       :value="item.value"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="baseSearchOne">
                    <el-button type="primary" style="margin-left: 20px;" @click="detailSearch">搜索</el-button>
                    <el-button @click="detailCleanAll">清空</el-button>
                </div>
            </div>
            <div class="rtDetailOperate baseOperate clearfloat">
                <div class="baseOperateOne tableButton" style="float: left;">
                    <el-tag size="large">应缴金额：{{detail_total_price.price}}元</el-tag>
                </div>
                <div class="baseOperateOne tableButton" style="float: left;">
                    <el-tag size="large">待缴金额：{{detail_total_price.be_received_price}}元</el-tag>
                </div>
                <div class="baseOperateOne tableButton" style="float: left;">
                    <el-tag size="large">已缴齐人数：{{detail_total_price.yi_count}}</el-tag>
                </div>
                <div class="baseOperateOne" style="float: left;">
                    <el-tag size="large">未缴齐人数：{{detail_total_price.wei_count}}</el-tag>
                </div>
                <div class="baseOperateOne">
                    <el-button type="primary" @click="openDetailExport">导出全部</el-button>
                </div>
            </div>
            <div class="baseTable">
                <publicTable :publicTableOtherHeight="(detailSearchHeight+16)" :publicTableData="detailTableData">
                    <el-table-column prop="project_name" label="项目名"></el-table-column>
                    <el-table-column prop="class_name" label="组织部门"></el-table-column>
                    <el-table-column prop="card_number" label="学工号"></el-table-column>
                    <el-table-column prop="user_name" label="姓名"></el-table-column>
                    <el-table-column prop="received_price" label="已缴金额"></el-table-column>
                    <el-table-column prop="be_received_price" label="待缴金额"></el-table-column>
                    <el-table-column label="是否欠费">
                        <template #default="scope">
                            {{is_arrears_obj[scope.row.is_arrears]}}
                        </template>
                    </el-table-column>
                </publicTable>
            </div>
            <div class="basePage" style="margin-top: 4px;">
                <publicPage ref="detailPageUserStudent" :publicPageTotal="{total:detailTotal}"
                            @pageChange="getDetailTableData"></publicPage>
            </div>
        </el-drawer>
    </div>
</template>

<script>

    import publicPage from '../../components/publicPage.vue'

    import publicTable from '../../components/publicTable.vue'

    import XLSX from 'xlsx'

    import {businessGet} from '../../api/business.js'

    import Global from '../../Global.js'

    import {utilsExportExcel} from '../../utils/utils.js'

    export default {
        name: "payDepartmentReport",
        components: {
            publicPage,
            publicTable
        },
        data() {
            return {
                userInfo: JSON.parse(localStorage.getItem(Global.GlobalLocalName2)),
                project_id_list: [],
                class_id_list: [],
                props: {
                    value: 'id',
                    label: 'name',
                    children: 'son',
                    checkStrictly: true
                },
                searchForm: {
                    project_id: '',
                    org_id: '',
                },
                searchHeight: 300,
                tableLoading: false,
                tableData: [],
                total: 0,
                drawer: false,
                is_arrears_obj: {
                    "1": "是",
                    "0": "否"
                },
                is_arrears_list: [
                    {
                        value: '1',
                        label: '是'
                    },
                    {
                        value: '0',
                        label: '否'
                    }
                ],
                detailSearchForm: {
                    user_name: '',
                    is_arrears: '',
                    project_id: '',
                },
                detailSearchHeight: 0,
                detail_total_price: {
                    be_received_price: 0,
                    price: 0,
                    wei_count: 0,
                    yi_count: 0,
                },
                detailTableData: [],
                detailTotal: 0,
            }
        },
        mounted() {
            this.get_project_id_list();
            this.getTreeData();
            this.$nextTick(() => {
                let baseSearchDom = document.querySelector('.baseSearch');
                let searchHeight = baseSearchDom.offsetHeight + 10;
                this.searchHeight = searchHeight;
                this.cleanAll()
            })
        },
        methods: {
            openDetailExport() {
                let url = '/admin/v1/org_report_info?is_export=1&org_id=' + this.selMsg.id;
                for (let k in this.detailSearchForm) {
                    if (this.detailSearchForm[k]) {
                        url = url + '&' + k + '=' + this.detailSearchForm[k];
                    }
                }
                utilsExportExcel(url)
            },
            detailExportExcel() {
                this.$confirm('此操作将下载文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    //数据表格
                    let exportList = [];
                    var aoa = [
                        ['支付宝账号', '支付宝账号姓名', '转账金额', '转账人', '转账时间', '转账状态', '备注'],
                    ];
                    let dayinName = ['receiverId', 'receiverName', 'transAmount', 'operaterName', 'fuTransDate', 'statusName', 'remark']
                    exportList.forEach(item => {
                        let a = []
                        dayinName.forEach(item2 => {
                            a.push(item[item2])
                        })
                        aoa.push(a)
                    })
                    //创建book
                    var wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.aoa_to_sheet(aoa);
                    //设置列宽
                    ws['!cols'] = [
                        {width: 20},
                        {width: 20},
                        {width: 20},
                        {width: 20},
                        {width: 20},
                        {width: 20},
                    ];
                    XLSX.utils.book_append_sheet(wb, ws, "sheet1");
                    //输出
                    let exportName = "转账记录.xlsx"
                    XLSX.writeFile(wb, exportName);
                }).catch(() => {
                })
            },
            detailCleanAll() {
                this.detailSearchForm.user_name = '';
                this.detailSearchForm.is_arrears = '';
                this.detailSearchForm.project_id = '';
                this.detailSearch();
            },
            detailSearch() {
                this.$refs.detailPageUserStudent.currentPage = 1;
                this.getDetailTableData();
            },
            getDetailTableData() {
                let url = '/admin/v1/org_report_info?org_id=' + this.selMsg.id + '&page=' + this.$refs.detailPageUserStudent.currentPage + '&page_pre=' + this.$refs.detailPageUserStudent.pageSize;
                for (let k in this.detailSearchForm) {
                    if (this.detailSearchForm[k]) {
                        url = url + '&' + k + '=' + this.detailSearchForm[k];
                    }
                }
                businessGet(url).then(res => {
                    if (res.data.status == 200) {
                        this.detailTotal = res.data.data.count;
                        this.detailTableData = res.data.data.list;
                        if (res.data.data.total.be_received_price != null) {
                            this.detail_total_price.be_received_price = res.data.data.total.be_received_price;
                        }
                        if (res.data.data.total.price != null) {
                            this.detail_total_price.price = res.data.data.total.price;
                        }
                        if (res.data.data.total.wei_count != null) {
                            this.detail_total_price.wei_count = res.data.data.total.wei_count;
                        }
                        if (res.data.data.total.yi_count != null) {
                            this.detail_total_price.yi_count = res.data.data.total.yi_count;
                        }
                    }
                    else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'warning'
                        });
                    }
                })
            },
            openDetail(val) {
                this.selMsg = val;
                this.drawer = true;
                this.$nextTick(() => {
                    let baseSearchDom = document.querySelector('.rtDetailSearch');
                    let baseOperateDom = document.querySelector('.rtDetailOperate');
                    let searchHeight = baseSearchDom.offsetHeight + baseOperateDom.offsetHeight;
                    this.detailSearchHeight = searchHeight;
                    this.detailSearchForm.user_name = '';
                    this.detailSearchForm.is_arrears = '';
                    this.detailSearchForm.project_id = this.searchForm.project_id;
                    this.detailSearch();
                })
            },
            openExport() {
                let url = '/admin/v1/operation?is_export=1';
                for (let k in this.searchForm) {
                    if (this.searchForm[k]) {
                        if (k == 'org_id') {
                            url = url + '&' + k + '=' + this.searchForm[k][this.searchForm[k].length - 1];
                        }
                        else {
                            url = url + '&' + k + '=' + this.searchForm[k];
                        }
                    }
                }
                utilsExportExcel(url)
            },
            exportExcel() {
                //数据表格
                var aoa = [
                    ['表格在此', '', '', ''],
                    ['', '', '', ''],
                    ['姓名', '性别', '年龄', '注册时间'],
                    ['张三', '男', 18, new Date()],
                    ['李四', '女', 22, new Date()]
                ];

                //创建book
                var wb = XLSX.utils.book_new();

                var ws = XLSX.utils.aoa_to_sheet(aoa);
                //设置列宽
                ws['!cols'] = [
                    {width: 50},
                    {width: 15},
                    {width: 15},
                    {width: 10}
                ];
                ws['!merges'] = [
                    // 设置A1-C1的单元格合并
                    {
                        s: {r: 0, c: 0},
                        e: {r: 1, c: 3}
                    }
                ];

                ws['A3'].l = {Target: "http://sheetjs.com", Tooltip: "Find us @ SheetJS.com!"};

                var aoa2 = [
                    ['姓名', '性别', '年龄', '注册时间'],
                    ['张三', '男', 18, new Date()],
                    ['李四', '女', 22, new Date()]
                ];

                var ws2 = XLSX.utils.aoa_to_sheet(aoa2);

                ws2["A1"].s = {
                    font: {sz: 14, bold: true, vertAlign: true},
                    alignment: {vertical: "center", horizontal: "center"},
                    fill: {bgColor: {rgb: "E8E8E8"}, fgColor: {rgb: "E8E8E8"}}
                };

                var aoa3 = [
                    ['姓名', '性别', '年龄', '注册时间'],
                    ['张三', '男', 18, new Date()],
                    ['李四', '女', 22, new Date()]
                ];

                var ws3 = XLSX.utils.aoa_to_sheet(aoa3);
                ws3["!margins"] = {left: 0.25, right: 0.25, top: 0.75, bottom: 0.75, header: 0.3, footer: 0.3}

                //sheet写入book
                XLSX.utils.book_append_sheet(wb, ws, "操作合并，列宽");
                XLSX.utils.book_append_sheet(wb, ws2, "正常");
                XLSX.utils.book_append_sheet(wb, ws3, "操作间隔");

                //输出

                var timestamp = (new Date()).getTime();
                XLSX.writeFile(wb, "file" + timestamp + ".csv");
            },
            cleanAll() {
                this.searchForm.project_id = '';
                this.searchForm.org_id = '';
                this.search();
            },
            search() {
                this.$refs.publicPageUserStudent.currentPage = 1;
                this.getTableData();
            },
            getTableData() {
                let url = '/admin/v1/org_report?page=' + this.$refs.publicPageUserStudent.currentPage + '&page_pre=' + this.$refs.publicPageUserStudent.pageSize;
                for (let k in this.searchForm) {
                    console.log(k, this.searchForm[k]);
                    if (this.searchForm[k]) {
                        if (k == 'org_id') {
                            url = url + '&' + k + '=' + this.searchForm[k][this.searchForm[k].length - 1];
                        }
                        else {
                            url = url + '&' + k + '=' + this.searchForm[k];
                        }
                    }
                }
                this.tableLoading = true;
                businessGet(url).then(res => {
                    this.tableLoading = false;
                    if (res.data.status == 200) {
                        this.total = res.data.data.count;
                        this.tableData = res.data.data.list;
                    }
                    else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'warning'
                        });
                    }
                })
            },
            get_project_id_list() {
                let url = '/admin/v1/projects?page=1&page_pre=500';
                businessGet(url).then(res => {
                    if (res.data.status == 200) {
                        let newArray = [];
                        res.data.data.list.forEach(item => {
                            let a = {
                                value: item.id,
                                label: item.name
                            }
                            newArray.push(a);
                        })
                        this.project_id_list = newArray;
                    }
                    else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'warning'
                        });
                    }
                })
            },
            getTreeData() {
                let url = '/admin/v1/organization?type=1';
                businessGet(url).then(res => {
                    if (res.data.status == 200) {
                        this.class_id_list = res.data.data;
                        this.class_id_list.push({
                            id: -1,
                            name: '未分配'
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

    @import "../../assets/css/base.css";

</style>
